(function () {
	'use strict';

	/**
	 * @ngdoc directive
	 * @name smb-app.directive:smbadminUsers
	 * @module smb-app
	 * @restrict E
	 * @description
	 *
	 * `smbadminUsers` displays a deployments users
	 *
	 * @usage
	 *
	 * <sbadmin-users deployment-id="1" />
	 *
	 * @element input
	 * @param {number=} deploymentId The id of the deployment display api tokens for
	 */

	angular.module('smb-app')
		.directive('smbadminUsers', [UsersDirective])
		.controller('smbadminUsersController',
		[
			'$state',
			'gettextCatalog',
			'pxProgressService',
			'smbToolbarService',
			'smbUsersDataStore',
			UsersController
		]);

	var templateUrl = require('./users.template');
	function UsersDirective() {
		return {
			restrict: 'E',
			controller: 'smbadminUsersController',
			controllerAs: 'vm',
			templateUrl: templateUrl,
			bindToController: true,
			scope: {}
		};
	}

	function UsersController($state, gettextCatalog, pxProgressService, smbToolbarService, smbUsersDataStore) {
		var vm = this;
		smbToolbarService.set(gettextCatalog.getString('Users Configuration'), 'useradmin.home');

		vm.smbUsersDataStore = smbUsersDataStore;
		vm.pxProgressService = pxProgressService;
		vm.editUser = editUser;
		vm.createUser = createUser;

		function editUser(user) {
			$state.go('useradmin.home.users.details', { userId: user.UserId });
		}

		function createUser() {
			$state.go('useradmin.home.users.details', { userId: '' });
		}

		//initialize
		(function loadUsers() {
			pxProgressService.visible = true;
			vm.smbUsersDataStore.getUsers().finally(function () { pxProgressService.visible = false; });
		}());
	}

}());


//////////////////
// WEBPACK FOOTER
// ./app/components/users/users.js
// module id = 105
// module chunks = 1